import { create } from "zustand";

export const ObraStore = create((set) => ({
  gerenciaPropriedadeValue: null,
  maoDeObraValue: null,
  organizacaoValue: null,

  obraMapImage: null,
  gerenciaPropriedadeImage: null,
  maoDeObraImage: null,
  organizacaoImage: null,
  assistenciaTecnicaImage: null,

  setGerenciaPropriedadeValue: (val) => set({ gerenciaPropriedadeValue: val }),

  setMaoDeObraValue: (val) => set({ maoDeObraValue: val }),

  setOrganizacaoValue: (val) => set({ organizacaoValue: val }),


  setObraMapImage: (img) => set({ obraMapImage: img }),

  setGerenciaPropriedadeImage: (img) => set({ gerenciaPropriedadeImage: img }),

  setMaoDeObraImage: (img) => set({ maoDeObraImage: img }),

  setOrganizacaoImage: (img) => set({ organizacaoImage: img }),

  setAssistenciaTecnicaImage: (img) => set({assistenciaTecnicaImage: img}),

  reset: () =>
    set({
      gerenciaPropriedadeValue: null,
      maoDeObraValue: null,
      organizacaoValue: null,
    }),
}));
